import { Component } from 'react';
import { Alert } from 'react-bootstrap';
import AttributionWindow from '../../../generic/AttributionWindow';
import PublishSBOMReportControl from './PublishSBOMReportControl';
import styles from './HTMLPreview.module.less';
import { FeatureFlagRequired } from '../../../generic';
import { SBOM_PORTAL } from '../../../../../shared/featureFlags/flagNames';
import { window } from '../../../../globals';
import { Action, ResourceType } from '../../../../../typings/permissions';
import HTMLPreviewContent from './HTMLPreviewContent';

type HTMLPreviewProps = {
  projectType: string;
  previewURL: string;
  format?: string;
  isSecurityReport?: boolean;
};

type HTMLPreviewState = {
  loading: boolean;
  error?: string;
};

const acceptedFormatsForSBOM = ['CYCLONEDX_JSON', 'CYCLONEDX_XML', 'SPDX', 'SPDX_JSON'];
const acceptedFormatsForAttribution = ['TXT'];
const acceptedFormatsForPortal = acceptedFormatsForAttribution.concat(acceptedFormatsForSBOM);

export default class HTMLPreview extends Component<HTMLPreviewProps, HTMLPreviewState> {
  state = {
    loading: true,
    error: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.previewURL !== prevProps.previewURL) {
      // This won't runaway rerender

      this.setState({ loading: true, error: null });
    }
  }

  render() {
    const { error, loading: isLoading } = this.state;
    if (error) {
      return <Alert bsStyle="error">An error occurred: {error}</Alert>;
    }
    const { format, previewURL, isSecurityReport, projectType } = this.props;
    const hasPermissionToEditPortalSettings =
      window.hasPermission({ resourceType: ResourceType.OrganizationPortalReports, action: Action.Manage });
    const shouldDisplayPortalControl =
      acceptedFormatsForPortal.includes(format || '') && projectType === 'releaseGroup' && hasPermissionToEditPortalSettings;
    const reportType = format && acceptedFormatsForSBOM.includes(format) ? 'SBOM' : 'Attribution';
    return (
      <div className={styles.preview}>
        <Alert>
          Previews show a limited number of dependencies{isSecurityReport ? '' : ' and licenses'}. Please download for a complete report.
        </Alert>
        <FeatureFlagRequired flagName={SBOM_PORTAL}>
          {shouldDisplayPortalControl && <PublishSBOMReportControl reportType={reportType} />}
        </FeatureFlagRequired>
        <AttributionWindow isLoading={isLoading}>
          <HTMLPreviewContent
            format={format as string}
            isLoading={isLoading}
            previewURL={previewURL}
            setErrorMessage={(errorMessage) => this.setState({ error: errorMessage })}
            setIsLoading={(loading) => this.setState({ loading })}
          />
        </AttributionWindow>
      </div>
    );
  }
}
